/**
 * "Geen prijs" for a meerwerk the server cannot price (a km line it would refuse:
 * no price, another unit or currency, a duplicate km product). The reason is the
 * server's Dutch message. Callers show no amount or total for such a line.
 */
export function GeenPrijsLabel({ reason, className = '' }: { reason?: string | null; className?: string }) {
  return (
    <span className={`text-red-600 ${className}`} title={reason ?? undefined}>
      <span className="font-semibold">Geen prijs</span>
      {reason && <span className="block text-[11px] font-normal text-red-500 whitespace-normal">{reason}</span>}
    </span>
  );
}
